NP.StickerData = [
  //gid 1------------------------------------------------
[ {"sid": 100, "name": "남소유_공포" },
  { "sid": 101, "name": "남소유_슬픔" },
  { "sid": 102, "name": "남소유_행복" },
  { "sid": 103, "name": "진서연_거절" },
  { "sid": 104, "name": "진서연_깔깔" },
  { "sid": 105, "name": "진서연_썩소" },
  { "sid": 106, "name": "홍석근_딴청" },
  { "sid": 107, "name": "홍석근_아픔" },
  { "sid": 108, "name": "홍석근_힘내" },
  { "sid": 109, "name": "홍석근_분노" },
  { "sid": 110, "name": "남소유_갈망" },
  { "sid": 111, "name": "남소유_감사" },
  { "sid": 112, "name": "남소유_더위" },
  { "sid": 113, "name": "남소유_부탁" },
  { "sid": 114, "name": "남소유_슬픔2" },
  { "sid": 115, "name": "남소유_슬픔3" },
  { "sid": 116, "name": "남소유_애교" },
  { "sid": 117, "name": "남소유_애교2" },
  { "sid": 118, "name": "남소유_인사" },
  { "sid": 119, "name": "남소유_자신감" },
  { "sid": 120, "name": "남소유_즐거움" },
  { "sid": 121, "name": "남소유_최고" },
  { "sid": 122, "name": "남소유_납치" },
  { "sid": 123, "name": "남소유_수면" },
  { "sid": 124, "name": "진서연_감시" },
  { "sid": 125, "name": "진서연_미안" },
  { "sid": 126, "name": "진서연_슬픔" },
  { "sid": 127, "name": "진서연_슬픔2" },
  { "sid": 128, "name": "진서연_여유" },
  { "sid": 129, "name": "진서연_웃음" },
  { "sid": 130, "name": "진서연_행복" },
  { "sid": 131, "name": "홍석근_게임중" },
  { "sid": 132, "name": "홍석근_깜짝" },
  { "sid": 133, "name": "홍석근_슬픔" },
  { "sid": 134, "name": "홍석근_식사" },
  { "sid": 135, "name": "홍석근_여유" },
  { "sid": 136, "name": "홍석근_홍작별" },
  { "sid": 137, "name": "홍석근_찌뿌둥" },
  { "sid": 138, "name": "홍석근_괴롭힘" },
  { "sid": 139, "name": "홍석근_야단" }],

  //gid 2------------------------------------------------
[ {"sid": 200, "name": "GrGr_ㅇㅇ" },
  { "sid": 201, "name": "GrGr_ㄴㄴ" },
  { "sid": 202, "name": "GrGr_아잉" },
  { "sid": 203, "name": "GrGr_풉" },
  { "sid": 204, "name": "GrGr_질러라" },
  { "sid": 205, "name": "GrGr_감격" },
  { "sid": 206, "name": "GrGr_무서운아이" },
  { "sid": 207, "name": "GrGr_절규" },
  { "sid": 208, "name": "GrGr_축하" },
  { "sid": 209, "name": "GrGr_ㅋㅋ" },
  { "sid": 210, "name": "GrGr_딴청" },
  { "sid": 211, "name": "GrGr_미안" },
  { "sid": 212, "name": "GrGr_탕탕" },
  { "sid": 213, "name": "GrGr_쥬금" },
  { "sid": 214, "name": "GrGr_짜증" },
  { "sid": 215, "name": "GrGr_한숨" },
  { "sid": 216, "name": "GrGr_거지" },
  { "sid": 217, "name": "GrGr_굽신" },
  { "sid": 218, "name": "GrGr_짱머겅" },
  { "sid": 219, "name": "GrGr_두번머겅" },
  { "sid": 220, "name": "GrGr_파티모집" },
  { "sid": 221, "name": "GrGr_파티지원" },
  { "sid": 222, "name": "GrGr_은신" },
  { "sid": 223, "name": "GrGr_투시" },
  { "sid": 224, "name": "GrGr_반사" },
  { "sid": 225, "name": "GrGr_힐힐" }],

  //gid 3------------------------------------------------
[ {"sid": 300, "name": "대충말해_하이YO" },
  { "sid": 301, "name": "대충말해_그립구만YO" },
  { "sid": 302, "name": "대충말해_기역시옷YO" },
  { "sid": 303, "name": "대충말해_노노YO" },
  { "sid": 304, "name": "대충말해_그래YO" },
  { "sid": 305, "name": "대충말해_엉엉YO" },
  { "sid": 306, "name": "대충말해_뭘까YO" },
  { "sid": 307, "name": "대충말해_함께싸워YO" },
  { "sid": 308, "name": "대충말해_아디YO스" },
  { "sid": 309, "name": "대충말해_풋풋해YO" },
  { "sid": 310, "name": "대충말해_지쳐YO" },
  { "sid": 311, "name": "대충말해_추카YO" },
  { "sid": 312, "name": "대충말해_귓방맹이YO" },
  { "sid": 313, "name": "대충말해_엄마왔어YO" },
  { "sid": 314, "name": "대충말해_각오해YO" },
  { "sid": 315, "name": "대충말해_YO" },
  { "sid": 316, "name": "대충말해_아이러브YO" },
  { "sid": 317, "name": "대충말해_입술줘YO" },
  { "sid": 318, "name": "대충말해_웃겨YO" },
  { "sid": 319, "name": "대충말해_화나YO" },
  { "sid": 320, "name": "대충말해_잠수타YO" },
  { "sid": 321, "name": "대충말해_내가껌이YO" },
  { "sid": 322, "name": "대충말해_내포라말라YO" },
  { "sid": 323, "name": "대충말해_뽀찌줘YO" }],

  //gid 4------------------------------------------------
[ {"sid": 400, "name": "좌충우돌_안녕" },
  { "sid": 401, "name": "좌충우돌_뭬야" },
  { "sid": 402, "name": "좌충우돌_축하축하" },
  { "sid": 403, "name": "좌충우돌_애드" },
  { "sid": 404, "name": "좌충우돌_잘난척" },
  { "sid": 405, "name": "좌충우돌_뿌잉뿌잉" },
  { "sid": 406, "name": "좌충우돌_파티모집" },
  { "sid": 407, "name": "좌충우돌_슬퍼" },
  { "sid": 408, "name": "좌충우돌_흥칫뿌" },
  { "sid": 409, "name": "좌충우돌_오마이갓" },
  { "sid": 410, "name": "좌충우돌_굳잡" },
  { "sid": 411, "name": "좌충우돌_생각중" },
  { "sid": 412, "name": "좌충우돌_멘탈붕괴" },
  { "sid": 413, "name": "좌충우돌_힐링" },
  { "sid": 414, "name": "좌충우돌_감사감사" },
  { "sid": 415, "name": "좌충우돌_해탈" },
  { "sid": 416, "name": "좌충우돌_은신" },
  { "sid": 417, "name": "좌충우돌_미안해" },
  { "sid": 418, "name": "좌충우돌_화르륵" },
  { "sid": 419, "name": "좌충우돌_와락" },
  { "sid": 420, "name": "좌충우돌_피곤" },
  { "sid": 421, "name": "좌충우돌_멱살" },
  { "sid": 422, "name": "좌충우돌_파이팅" },
  { "sid": 423, "name": "좌충우돌_스윽" }],

  //gid 5------------------------------------------------
[ {"sid": 500, "name": "행동지침서_각성" },
  { "sid": 501, "name": "행동지침서_헉" },
  { "sid": 502, "name": "행동지침서_오잉" },
  { "sid": 503, "name": "행동지침서_미안" },
  { "sid": 504, "name": "행동지침서_분노" },
  { "sid": 505, "name": "행동지침서_좋아" },
  { "sid": 506, "name": "행동지침서_하악" },
  { "sid": 507, "name": "행동지침서_똥망" },
  { "sid": 508, "name": "행동지침서_하이" },
  { "sid": 509, "name": "행동지침서_행복" },
  { "sid": 510, "name": "행동지침서_가자" },
  { "sid": 511, "name": "행동지침서_하하" },
  { "sid": 512, "name": "행동지침서_힐좀" },
  { "sid": 513, "name": "행동지침서_긁적" },
  { "sid": 514, "name": "행동지침서_끙" },
  { "sid": 515, "name": "행동지침서_바이" },
  { "sid": 516, "name": "행동지침서_엉엉" },
  { "sid": 517, "name": "행동지침서_제시" },
  { "sid": 518, "name": "행동지침서_도전" },
  { "sid": 519, "name": "행동지침서_메디테이션" },
  { "sid": 520, "name": "행동지침서_덜덜" },
  { "sid": 521, "name": "행동지침서_크크" },
  { "sid": 522, "name": "행동지침서_최고" },
  { "sid": 523, "name": "행동지침서_피스" }],

  //gid 6------------------------------------------------
[ {"sid": 600, "name": "플러스_충격" },
  { "sid": 601, "name": "플러스_심심해" },
  { "sid": 602, "name": "플러스_감동" },
  { "sid": 603, "name": "플러스_화장실" },
  { "sid": 604, "name": "플러스_심봤다" },
  { "sid": 605, "name": "플러스_FAIL" },
  { "sid": 606, "name": "플러스_헐" },
  { "sid": 607, "name": "플러스_헬프미" },
  { "sid": 608, "name": "플러스_안녕" },
  { "sid": 609, "name": "플러스_협박" },
  { "sid": 610, "name": "플러스_접속해" },
  { "sid": 611, "name": "플러스_안돼" },
  { "sid": 612, "name": "플러스_비웃음" },
  { "sid": 613, "name": "플러스_잘난척" },
  { "sid": 614, "name": "플러스_삐짐" },
  { "sid": 615, "name": "플러스_ㅋㅋㅋ" },
  { "sid": 616, "name": "플러스_미안" },
  { "sid": 617, "name": "플러스_내가최고" },
  { "sid": 618, "name": "플러스_옛생각" },
  { "sid": 619, "name": "플러스_저랩훈계" },
  { "sid": 620, "name": "플러스_밤샜어" },
  { "sid": 621, "name": "플러스_나를따르라" }],

  //gid 7------------------------------------------------
[ {"sid": 700, "name": "친절돋는_큰절" },
  { "sid": 701, "name": "친절돋는_go" },
  { "sid": 702, "name": "친절돋는_식겁" },
  { "sid": 703, "name": "친절돋는_궁금" },
  { "sid": 704, "name": "친절돋는_오키" },
  { "sid": 705, "name": "친절돋는_꽃" },
  { "sid": 706, "name": "친절돋는_헐" },
  { "sid": 707, "name": "친절돋는_아니" },
  { "sid": 708, "name": "친절돋는_흥" },
  { "sid": 709, "name": "친절돋는_즐거워" },
  { "sid": 710, "name": "친절돋는_지름" },
  { "sid": 711, "name": "친절돋는_하이" },
  { "sid": 712, "name": "친절돋는_절망" },
  { "sid": 713, "name": "친절돋는_대답바람" },
  { "sid": 714, "name": "친절돋는_뒷목" },
  { "sid": 715, "name": "친절돋는_분노" },
  { "sid": 716, "name": "친절돋는_죄송" },
  { "sid": 717, "name": "친절돋는_삽질중" },
  { "sid": 718, "name": "친절돋는_선물" },
  { "sid": 719, "name": "친절돋는_신난다" },
  { "sid": 720, "name": "친절돋는_사랑해" },
  { "sid": 721, "name": "친절돋는_잘가" }],

  //gid 8------------------------------------------------
[ {"sid": 800, "name": "빈유_안녕" },
  { "sid": 801, "name": "빈유_뭐해" },
  { "sid": 802, "name": "빈유_최고" },
  { "sid": 803, "name": "빈유_운기조식" },
  { "sid": 804, "name": "빈유_한판붙자" },
  { "sid": 805, "name": "빈유_샤방샤방" },
  { "sid": 806, "name": "빈유_혈압" },
  { "sid": 807, "name": "빈유_태장금나무토막" },
  { "sid": 808, "name": "빈유_졸려" },
  { "sid": 809, "name": "빈유_zzz" },
  { "sid": 810, "name": "빈유_바뻐" },
  { "sid": 811, "name": "빈유_됐고" },
  { "sid": 812, "name": "빈유_충격" },
  { "sid": 813, "name": "빈유_근성" },
  { "sid": 814, "name": "빈유_거절" },
  { "sid": 815, "name": "빈유_일어나시게" },
  { "sid": 816, "name": "빈유_흥분" },
  { "sid": 817, "name": "빈유_눈물" },
  { "sid": 818, "name": "빈유_짝짝짝" },
  { "sid": 819, "name": "빈유_반성중" },
  { "sid": 820, "name": "빈유_키스" },
  { "sid": 821, "name": "빈유_반함" }],

  //gid 9------------------------------------------------
[ {"sid": 900, "name": "빠가뇽_완전신나" },
  { "sid": 901, "name": "빠가뇽_폭풍애드" },
  { "sid": 902, "name": "빠가뇽_살아있냐" },
  { "sid": 903, "name": "빠가뇽_두두두" },
  { "sid": 904, "name": "빠가뇽_물어" },
  { "sid": 905, "name": "빠가뇽_뒹굴" },
  { "sid": 906, "name": "빠가뇽_배고파" },
  { "sid": 907, "name": "빠가뇽_장미꽃" },
  { "sid": 908, "name": "빠가뇽_닭쳐" },
  { "sid": 909, "name": "빠가뇽_토닥" },
  { "sid": 910, "name": "빠가뇽_후다닥" },
  { "sid": 911, "name": "빠가뇽_풉" },
  { "sid": 912, "name": "빠가뇽_관심좀" },
  { "sid": 913, "name": "빠가뇽_이놈의인기" },
  { "sid": 914, "name": "빠가뇽_놀아줘" },
  { "sid": 915, "name": "빠가뇽_Good" },
  { "sid": 916, "name": "빠가뇽_이쁜짓" },
  { "sid": 917, "name": "빠가뇽_춤" },
  { "sid": 918, "name": "빠가뇽_부끄" },
  { "sid": 919, "name": "빠가뇽_고독" },
  { "sid": 920, "name": "빠가뇽_약속" },
  { "sid": 921, "name": "빠가뇽_굿밤" },
  { "sid": 922, "name": "빠가뇽_bye" },
  { "sid": 923, "name": "빠가뇽_진상" }],

  //gid 10------------------------------------------------
[ {"sid": 1000, "name": "k_짱" },
  { "sid": 1001, "name": "k_쫌" },
  { "sid": 1002, "name": "k_콜" },
  { "sid": 1003, "name": "k_쉿" },
  { "sid": 1004, "name": "k_흥" },
  { "sid": 1005, "name": "k_뿅" },
  { "sid": 1006, "name": "k_힘내" },
  { "sid": 1007, "name": "k_니가" },
  { "sid": 1008, "name": "k_움찔" },
  { "sid": 1009, "name": "k_오호" },
  { "sid": 1010, "name": "k_어때" },
  { "sid": 1011, "name": "k_외롭다옹" },
  { "sid": 1012, "name": "k_뚝뚝" },
  { "sid": 1013, "name": "k_뿡" },
  { "sid": 1014, "name": "k_버럭" },
  { "sid": 1015, "name": "k_두근두근" },
  { "sid": 1016, "name": "k_토닥토닥" },
  { "sid": 1017, "name": "k_짝짝짝" },
  { "sid": 1018, "name": "k_불금" },
  { "sid": 1019, "name": "k_그저웃지요" },
  { "sid": 1020, "name": "k_지켜보고있다" },
  { "sid": 1021, "name": "k_미안하다사랑한다" },
  { "sid": 1022, "name": "k_참잘했어요" },
  { "sid": 1023, "name": "k_참잘났어요" }],

  //gid 11------------------------------------------------
[ {"sid": 1100, "name": "e_Hi" },
  { "sid": 1101, "name": "e_Bye" },
  { "sid": 1102, "name": "e_Smile" },
  { "sid": 1103, "name": "e_Good" },
  { "sid": 1104, "name": "e_Bad" },
  { "sid": 1105, "name": "e_Have a nice day" },
  { "sid": 1106, "name": "e_Good morning" },
  { "sid": 1107, "name": "e_Good night" },
  { "sid": 1108, "name": "e_Rainy day" },
  { "sid": 1109, "name": "e_Sorry" },
  { "sid": 1110, "name": "e_Thank you" },
  { "sid": 1111, "name": "e_OMG" },
  { "sid": 1112, "name": "e_OTL" },
  { "sid": 1113, "name": "e_Diet" },
  { "sid": 1114, "name": "e_Tea time" },
  { "sid": 1115, "name": "e_Wow" },
  { "sid": 1116, "name": "e_Oops" },
  { "sid": 1117, "name": "e_Yeah" },
  { "sid": 1118, "name": "e_Thinking of you" },
  { "sid": 1119, "name": "e_Just do it" },
  { "sid": 1120, "name": "e_Reset" },
  { "sid": 1121, "name": "e_Happy birthday" },
  { "sid": 1122, "name": "e_Congrats" },
  { "sid": 1123, "name": "e_Happy new year" },
  { "sid": 1124, "name": "e_Halloween" },
  { "sid": 1125, "name": "e_Christmas" },
  { "sid": 1126, "name": "e_1225" },
  { "sid": 1127, "name": "e_0214" },
  { "sid": 1128, "name": "e_0314" },
  { "sid": 1129, "name": "e_1111" }],

  //gid 12------------------------------------------------
[ {"sid": 1200, "name": "기르타스_거만" },
  { "sid": 1201, "name": "기르타스_당황" },
  { "sid": 1202, "name": "기르타스_화남" },
  { "sid": 1203, "name": "기르타스_슬픔" },
  { "sid": 1204, "name": "기르타스_깜찍" },
  { "sid": 1205, "name": "기르타스_놀람" },
  { "sid": 1206, "name": "기르타스_침묵" },
  { "sid": 1207, "name": "기르타스_샤방" },
  { "sid": 1208, "name": "기르타스_답답" },
  { "sid": 1209, "name": "기르타스_행복" },
  { "sid": 1210, "name": "기르타스_뻘쭘" },
  { "sid": 1211, "name": "기르타스_심각" }],

  //gid 13------------------------------------------------
[ {"sid": 1300, "name": "시크_love" },
  { "sid": 1301, "name": "시크_나잡아봐라" },
  { "sid": 1302, "name": "시크_넌내가지킨다" },
  { "sid": 1303, "name": "시크_반함" },
  { "sid": 1304, "name": "시크_완전반함" },
  { "sid": 1305, "name": "시크_뽀뽀" },
  { "sid": 1306, "name": "시크_바람" },
  { "sid": 1307, "name": "시크_선물" },
  { "sid": 1308, "name": "시크_movie" },
  { "sid": 1309, "name": "시크_뭐먹지" },
  { "sid": 1310, "name": "시크_teatime" },
  { "sid": 1311, "name": "시크_연인" },
  { "sid": 1312, "name": "시크_어장관리" },
  { "sid": 1313, "name": "시크_기대" },
  { "sid": 1314, "name": "시크_쵝오" },
  { "sid": 1315, "name": "시크_여행" },
  { "sid": 1316, "name": "시크_훗" },
  { "sid": 1317, "name": "시크_웃겨" },
  { "sid": 1318, "name": "시크_후릅" },
  { "sid": 1319, "name": "시크_몰라잉" },
  { "sid": 1320, "name": "시크_의기소침" },
  { "sid": 1321, "name": "시크_흑흑" },
  { "sid": 1322, "name": "시크_눈물" },
  { "sid": 1323, "name": "시크_잔소리" },
  { "sid": 1324, "name": "시크_퍽" },
  { "sid": 1325, "name": "시크_메롱" },
  { "sid": 1326, "name": "시크_분노" },
  { "sid": 1327, "name": "시크_공포" },
  { "sid": 1328, "name": "시크_째려보기" },
  { "sid": 1329, "name": "시크_당황" },
  { "sid": 1330, "name": "시크_휑" }]
];

NP.StickerData.list = [
    {
        cls : 'emoticon',
        tit : '이모티콘',
        gid : 0
    },
    {
        cls : 'bns',
        tit : '블레이드 &amp; 소울',
        gid : 1
    },
    {
        cls : 'grgr',
        tit : '가렛의 GrGr 아이온',
        gid : 2
    },
    {
        cls : 'sayyo',
        tit : '치싫의 대충말해 YO',
        gid : 3
    },
    {
        cls : 'noisy',
        tit : '배동의 좌충우돌 스티커',
        gid : 4
    },
    {
        cls : 'lineageguide',
        tit : '이레이의 리니지 행동 지침서',
        gid : 5
    },
    {
        cls : 'plus',
        tit : '하얀가루의 PLUS+',
        gid : 6
    },
    {
        cls : 'lovebeat',
        tit : '제3의 물결의 친절돋는 스티커',
        gid : 7
    },        
    {
        cls : 'astalos',
        tit : '빈유 충각단의 포화란',
        gid : 8
    },
    {
        cls : 'bgn',
        tit : '빠가뇽의 우당탕탕 블소',
        gid : 9
    },
    {
        cls : 'text_k',
        tit : 'Oops! 영어로 말해 Yo',
        gid : 10
    },
    {
        cls : 'text_e',
        tit : '뿅! 흥! 쉿! 재치있는 한글',
        gid : 11
    },
    {
        cls : 'kirtas',
        tit : '지배자의 부활 기르타스',
        gid : 12
    },
    {
        cls : 'chicover',
        tit : '시크 발랄한 연인들',
        gid : 13
    }
];
